import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/AuthProvider';
import { notificacaoService } from './notificacaoService';

export const notificacaoKeys = {
  all: ['notificacoes'] as const,
  resumo: () => ['notificacoes', 'resumo'] as const,
  lista: (naoLidas: boolean) => ['notificacoes', 'lista', naoLidas] as const,
};

const TAMANHO_POPOVER = 20;

/** Badge do sino. O WebSocket invalida ao chegar aviso novo; o polling e a rede de seguranca. */
export function useNotificacoesResumo(pollingAtivo: boolean) {
  const { user } = useAuth();
  const enabled = Boolean(user && user.idEscolaAtiva != null);
  return useQuery({
    queryKey: [...notificacaoKeys.resumo(), user?.idEscolaAtiva],
    queryFn: notificacaoService.resumo,
    enabled,
    staleTime: 15_000,
    refetchInterval: pollingAtivo ? 60_000 : false,
    refetchOnWindowFocus: true,
  });
}

export function useNotificacoesLista(aberto: boolean, naoLidas = false) {
  const { user } = useAuth();
  return useQuery({
    queryKey: [...notificacaoKeys.lista(naoLidas), user?.idEscolaAtiva],
    queryFn: () => notificacaoService.listar({ tamanho: TAMANHO_POPOVER, naoLidas }),
    enabled: aberto && user?.idEscolaAtiva != null,
    staleTime: 15_000,
  });
}

export function useMarcarNotificacaoLida() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => notificacaoService.marcarLida(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificacaoKeys.all }),
  });
}

export function useMarcarTodasNotificacoesLidas() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => notificacaoService.marcarTodasLidas(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificacaoKeys.all }),
  });
}
